import React from "react";
import { useActualites } from "@/data/hooks";
import { useLanguage } from "@/i18n/LanguageContext";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";

export default function Actualites() {
 const ACTUALITES = useActualites();
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;
 const dateLocale = locale === "en" ? "en-GB" : locale === "pt" ? "pt-PT" : "fr-FR";
 const formatDate = (iso) =>
 new Date(iso).toLocaleDateString(dateLocale, { day: "numeric", month: "long", year: "numeric" });

 return (
 <div data-testid="page-actualites">
 <section className="border-b border-nanda-line">
 <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-24 md:pt-40 pb-16 md:pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
 <FadeUp className="md:col-span-4">
 <div className="label-overline text-nanda-muted">{l("Actualités", "News", "Actualidades")}</div>
 </FadeUp>
 <FadeUp delay={0.1} className="md:col-span-8">
 <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-balance leading-[1.0]">{l("L'actualité du Groupe.", "The Group's news.", "As notícias do Grupo.")}</h1>
 <p className="mt-10 max-w-2xl text-nanda-inkSoft text-base md:text-lg leading-relaxed">
 {l(
 "Nouveaux produits, partenariats, salons, formations, suivez les avancées de nos cinq Maisons.",
 "New products, partnerships, trade fairs, training, follow the progress of our five Houses.",
 "Novos produtos, parcerias, feiras, formações, acompanhe os avanços das nossas cinco Casas."
 )}
 </p>
 </FadeUp>
 </div>
 </section>

 <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-16 md:py-24">
 <Stagger className="space-y-px bg-nanda-line border border-nanda-line">
 {ACTUALITES.map((a, i) => (
 <StaggerItem key={a.slug} className="bg-nanda-bg" data-testid={`actu-${a.slug}`}>
 <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center p-6 md:p-10">
 <div className="md:col-span-4 aspect-[5/3] overflow-hidden">
 <img src={a.cover} alt={a.title} loading="lazy" className="h-full w-full object-cover" />
 </div>
 <div className="md:col-span-1 label-overline text-nanda-muted">0{i + 1}</div>
 <div className="md:col-span-7">
 <div className="label-overline text-nanda-terracotta">{a.type} · {formatDate(a.date)}</div>
 <h3 className="font-serif text-3xl md:text-4xl mt-3 leading-tight">{a.title}</h3>
 <p className="mt-4 text-nanda-inkSoft text-base max-w-xl">{a.excerpt}</p>
 </div>
 </div>
 </StaggerItem>
 ))}
 </Stagger>
 </section>
 </div>
 );
}
